<template>
  <div>
    <div class="jm-white-container">
      <form>
        <div class="col-lg-10 mx-auto">
          <div class="col-12">
            <div class="h5 mb-3">Cinema: {{currentCinemaIndex}}/{{noOfCinemas}}</div>
          </div>
          <!-- <div class="row">
          <div class="col-md-12 mb-4">
            <div class="d-flex align-items-center">
              <div class="input-container w-100">
                <input type="text" placeholder="URL" />
              </div>
              <Tooltip :title="`Tooltip content`"  />
            </div>
            <p class="error_msg">Invaid Entry</p>
          </div>
          </div>-->

          <div class="col-md-12 text-center mb-4">
            <router-link
              to
              v-for="(level,levelKey) in levelList"
              :key="levelKey"
              v-on:click.native="onSelectLevel(level)"
              class="btn-blue-lg ml-2"
              :class="level.cl_name == selectedLevel.levelName ? 'active':''"
            >{{level.cl_name}}</router-link>
          </div>

          <div v-for="(hardware,hardwareKey) in selectedLevel.list" :key="hardwareKey">
            <p class="font-weight-bold">{{hardware.name}} - {{hardware.index}}</p>

            <div class="row">
              <div class="col-md-6 mb-4">
                <div class="d-flex align-items-center">
                  <div class="input-container w-100">
                    <input
                      v-model="hardware.userName"
                      :id="'userName'+hardwareKey"
                      type="text"
                      placeholder="Key"
                      name="username"
                      v-validate="'required|alpha_num'"
                    />
                    <label :for="'userName'+hardwareKey">User Name</label>
                  </div>
                  <Tooltip :title="`Tooltip content`"  />
                </div>
                <p
                  v-if="submitted && errors.has('username')"
                  class="error_message"
                >{{ errors.first('username') }}</p>
                <!-- <p class="error_msg">Invaid Entry</p> -->
              </div>

              <div class="col-md-6 mb-4">
                <div class="d-flex align-items-center">
                  <div class="input-container w-100">
                    <input
                      type="password"
                      v-model="hardware.userPassword"
                      :id="'password'+hardwareKey"
                      placeholder="Pass code"
                      name="password"
                      v-validate="{required: 'required', regex:/^(?=^.{4,15}$)[a-zA-Z0-9!@#$]*$/}"
                    />
                    <label :for="'password'+hardwareKey">Password</label>
                  </div>
                  <Tooltip :title="`Tooltip content`"  />
                </div>
                <p
                  v-if="submitted && errors.has('password')"
                  class="error_message"
                >{{ errors.first('password') }}</p>
              </div>
            </div>
          </div>
          <!-- </div> -->

          <!-- POS START -->

          <!-- POS END -->

          <!-- Kiosk Start -->
          <!-- <div v-for="(kisok,kioskey) in no_of_kiosk" :key="'kiosk'+kioskey">
          <p class="font-weight-bold">{{kioskey+1}} - Kiosk</p>

          <div :key="kioskey" class="row">
            <div class="col-md-6 mb-4">
              <div class="d-flex align-items-center">
                <div class="input-container w-100">
                  <input type="text" placeholder="Key" />
                </div>
                <Tooltip :title="`Tooltip content`"  />
              </div>
              <p class="error_msg">Invaid Entry</p>
            </div>

            <div class="col-md-6 mb-4">
              <div class="d-flex align-items-center">
                <div class="input-container w-100">
                  <input type="text" placeholder="Pass code" />
                </div>
                <Tooltip :title="`Tooltip content`"  />
              </div>
              <p class="error_msg">Invaid Entry</p>
            </div>
          </div>
          </div>-->
          <!-- Kiosk end -->

          <!-- fnb Start -->
          <!-- <div v-for="(fnb,fnkey) in no_of_fnb_counter" :key="'fnb'+fnkey">
          <p class="font-weight-bold">{{fnkey+1}} - F&B</p>

          <div :key="fnkey" class="row">
            <div class="col-md-6 mb-4">
              <div class="d-flex align-items-center">
                <div class="input-container w-100">
                  <input type="text" placeholder="Key" />
                </div>
                <Tooltip :title="`Tooltip content`"  />
              </div>
              <p class="error_msg">Invaid Entry</p>
            </div>

            <div class="col-md-6 mb-4">
              <div class="d-flex align-items-center">
                <div class="input-container w-100">
                  <input type="text" placeholder="Pass code" />
                </div>
                <Tooltip :title="`Tooltip content`"  />
              </div>
              <p class="error_msg">Invaid Entry</p>
            </div>
          </div>
          </div>-->
          <!-- fnb ends -->

          <!-- signage start -->
          <!-- <div v-for="(signage,signageKey) in no_of_signage" :key="'signage'+signageKey">
          <p class="font-weight-bold">{{signageKey+1}} - Signage</p>

          <div :key="signageKey" class="row">
            <div class="col-md-6 mb-4">
              <div class="d-flex align-items-center">
                <div class="input-container w-100">
                  <input type="text" placeholder="Key" />
                </div>
                <Tooltip :title="`Tooltip content`"  />
              </div>
              <p class="error_msg">Invaid Entry</p>
            </div>

            <div class="col-md-6 mb-4">
              <div class="d-flex align-items-center">
                <div class="input-container w-100">
                  <input type="text" placeholder="Pass code" />
                </div>
                <Tooltip :title="`Tooltip content`"  />
              </div>
              <p class="error_msg">Invaid Entry</p>
            </div>
          </div>
          </div>-->
          <!-- signage ends -->

          <div class="col-md-12 mx-auto text-center mt-5">
            <div class="row">
              <router-link class="btn-outline-blue-lg col" to="concession-counters">Back</router-link>
              <router-link class="btn-outline-blue-lg col mx-2" to="setup-add-user">Skip</router-link>
              <router-link
                v-if="(noOfCinemas > 1 || noOfCinemas > '1')"
                class="btn-outline-blue-lg col mx-2"
                :class="noOfCinemas == currentCinemaIndex ? 'd-none':''"
                v-on:click.native="onClickAddCinema()"
                to
              >Add Cinema</router-link>
              <router-link class="btn-blue-lg col" to v-on:click.native="onSubmit()">Proceed</router-link>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>
 <script>
import SetupService from "@/services/SetupService";
const PosObject = {
  userName: "",
  userPassword: ""
};

export default {
  data() {
    return {
      submitted: false,
      cacheKeys: [
        "Backup Configuration",
        "Setup Organization",
        "Add Cinema",
        "Cinema Configuration",
        "Finance Configuration",
        "Concession Levels"
      ],
      levelList: [],
      selectedCinema: {
        label: "Select Cinema"
      },
      counterLevels: [],
      selectedLevel: {},
      no_of_pos: 0,
      no_of_kiosk: 0,
      no_of_fnb_counter: 0,
      no_of_signage: 0
    };
  },
  mounted() {
    this.getCounterLevels();
  },
  computed: {
    noOfCinemas() {
      return this.$store.getters.NO_OF_CINEMAS || 1;
    },
    cinemas() {
      return this.$store.getters.CINEMAS;
    },
    currentCinemaIndex() {
      return this.$store.getters.currentCinemaIndex;
    }
  },
  methods: {
    onSelectHandler: function(cinema) {
      this.select.label = cinema.cine_name;
      this.getCounterLevels(cinema.cine_id);
    },
    getCounterLevels: function(cine_id) {
      let payload = {
        cine_id: window.localStorage.getItem("CURRENT_CINEMA_ID")
      };
      console.log(
        "CURRENT_CINEMA_ID ",
        window.localStorage.getItem("CURRENT_CINEMA_ID")
      );
      console.log("payload.cine_id ", payload.cine_id);
      SetupService.getCounterLevels(payload)
        .then(result => {
          const { data } = result;
          console.log("Dataa ", data);
          if (data.status && data.Records.length > 0) {
            let array = [
              { name: "POS Machine", key: "cld_no_of_pos" },
              { name: "KIOSK", key: "cld_no_of_kiosk" },
              { name: "FnB Counter", key: "cld_no_of_fnb_counters" },
              { name: "Signages", key: "cld_no_of_signages" }
            ];

            data.Records.map(z => {
              let tempArray = [];
              array.map(x => {
                for (let index = 0; index < parseInt(z[x.key]); index++) {
                  // const element = array[index];
                  tempArray.push({
                    ...x,
                    userName: "",
                    userPassword: "",
                    index: index + 1,
                    cinema_id:
                      window.localStorage.getItem("CURRENT_CINEMA_ID") || 1
                  });
                }
              });
              this.levelList.push({
                levelName: z.cl_name,
                ...z,
                list: tempArray
              });
            });
            // console.log("this.levelList :", this.levelList);
            this.selectedLevel = this.levelList[0];
            // this.counterLevels = data.Records;
            // this.selectedLevel = this.counterLevels[0];
            // this.no_of_pos = parseInt(this.selectedLevel.cld_no_of_pos);
            // this.no_of_kiosk = parseInt(this.selectedLevel.cld_no_of_kiosk);
            // this.no_of_fnb_counter = parseInt(
            //   this.selectedLevel.cld_no_of_fnb_counters
            // );
            // this.no_of_signage = parseInt(
            //   this.selectedLevel.cld_no_of_signages
            // );
          }
        })
        .catch(err => {
          console.log("err :", err);
        });
    },
    onClickAddCinema: function() {
      this.cacheKeys.map(x => {
        window.localStorage.removeItem(x);
      });
      this.$store.dispatch("setCurrentCinemaIndex");
      setTimeout(() => {
        console.log("object");
        this.$router.replace({
          path: "add-cinema-master"
        });
      }, 1000);
      // this.$nextTick(() => {
      // });
    },
    onSubmit: function() {
      this.submitted = true;
      this.$validator.validate().then(valid => {
        if (valid) {
          let payload = {
            levelList: this.levelList
          };
          SetupService.addHardwareSettings(payload)
            .then(response => {
              const { data } = response;
              if (data && data.status) {
                this.cacheKeys.map(x => {
                  window.localStorage.removeItem(x);
                });
                this.$router.push({
                  path: "setup-add-user"
                });
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch(err => {
              this.$toasted.show(err);
            });
        }
      });
    },
    onSelectLevel: function(level) {
      this.selectedLevel = level;
      // this.no_of_pos = parseInt(this.selectedLevel.cld_no_of_pos);
      // this.no_of_kiosk = parseInt(this.selectedLevel.cld_no_of_kiosk);
      // this.no_of_fnb_counter = parseInt(
      //   this.selectedLevel.cld_no_of_fnb_counters
      // );
      // this.no_of_signage = parseInt(this.selectedLevel.cld_no_of_signages);
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/cinemaInstallation/dataBaseConfiguration6.vue